import { mapActionsFromConfigurations } from '../../helpers/action';
import { configurations } from './configurations';

const actions = mapActionsFromConfigurations('onboarding')(configurations);

export { API_ENDPOINT, PLAN_ENDPOINT } from './configurations/endpoints';

export default actions;


// WEBPACK FOOTER //
// ./src/state/modules/global/actions.js